import React from 'react';
import { HeroSection } from '@/components/HeroSection';
import { TestimonialSection } from '@/components/TestimonialSection';
import { IndustryBanner } from '@/components/IndustryBanner';
import { AboutSection } from '@/components/AboutSection';
import { WhatIOffer } from '@/components/WhatIOffer';
import { ServicesSection } from '@/components/ServicesSection';
import { LogosBanner } from '@/components/LogosBanner';
import { TikTokSection } from '@/components/TikTokSection';
import { Footer } from '@/components/Footer';

const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <LogosBanner />
      <TestimonialSection />
      <IndustryBanner />
      <AboutSection />
      <WhatIOffer />
      <ServicesSection />
      <TikTokSection />
      <Footer />
    </>
  );
};

export default LandingPage;
